import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AppState, Auth0Provider } from '@auth0/auth0-react';
import history from './utils/history';
import config from './config';
import 'antd/dist/reset.css';
import NonSSOLanding from './views/NonSSOLanding';
import './App.css';


const onRedirectCallback = (appState?: AppState) => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};
const isSSO = config.ssoEnabled === 'true';

const IsSSORender = () => {
  return (
    <div>
      {
        isSSO ? (
          <Auth0Provider
            domain={config.domain}
            clientId={config.clientId}
            onRedirectCallback={onRedirectCallback}
            authorizationParams={{
              redirect_uri: window.location.origin,
              audience: config.audience
            }}
          >
            <App />
          </Auth0Provider >
        ) : (
          <NonSSOLanding />
        )
      }
    </div>
  );
}


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <>
    {IsSSORender()}
  </>
)




